import { Output, Component, Input, EventEmitter } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "cowing-element",
  templateUrl: "./cowing-element.component.html",
  styleUrls: ["./cowing-element.component.scss"],
})
export class CowingElementComponent {
  constructor(private translate: TranslateService) {}
  public daysOfWeek = [
    this.translate.instant("coworking.general.monday"),
    this.translate.instant("coworking.general.tuesday"),
    this.translate.instant("coworking.general.wednesday"),
    this.translate.instant("coworking.general.thursday"),
    this.translate.instant("coworking.general.friday"),
    this.translate.instant("coworking.general.saturday"),
    this.translate.instant("coworking.general.sunday"),
  ];
  @Input("label") label: any;
  @Input("selected") selected: boolean = false;
  @Input("schedule") schedule: any;
  @Input("index") indexSchedule: string;
  @Output("event") onClickEvent = new EventEmitter();
  iconsLibrary;
  onClick() {
    this.onClickEvent.emit(this.label);
  }
}
